import { render, staticRenderFns } from "./PolicyNew.vue?vue&type=template&id=ba16d4a8"
import script from "./PolicyNew.vue?vue&type=script&lang=js"
export * from "./PolicyNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports